import React from 'react';
import {useTranslation} from 'react-i18next';
import {TextInput} from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import {CredentialPicker} from '../../../FlowConfigurationInputs/CredentialPicker/CredentialPicker';
import AutomService from '../../../../services/AutomService/AutomService';
import {isActionValueController} from '../../../../helpers/helper';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

function Connect({automId, action, variables, setOpenVariable, showAlert, automVersionId}) {
    const {t} = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.SSH.CONNECT.';

    const handleClick = async () => {
        let res = isActionValueController(action.fields);
        if (res.indexOf(false) === -1) {
            action.automId = automId;
            action.automVersionId = automVersionId;
            let response = await AutomService.runAction(action);
            if (response) {
                showAlert(t('FLOW-MESSAGES.LIBRARY.' + response.message), response.status);
            }
        } else {
            showAlert(t('ACTIVE-DIRECTORY.NOT-NULL'), false);
        }
    }

    return (
        <div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'PATH')} is_required/>
                <TextInput action={action} inputName="path" variables={variables} setOpenVariable={setOpenVariable}
                           isRequired
                           fieldType='string' displayName={t(label + 'PATH')} hideRequired/>
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'USER')} is_required/>
                <CredentialPicker action={action} inputName="loginUser" variables={variables}
                                  setOpenVariable={setOpenVariable} isRequired hideRequired/>
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'PASSWORD')} is_required/>
                <CredentialPicker action={action} inputName="loginPassword" variables={variables}
                                  setOpenVariable={setOpenVariable} isRequired isPassword={true} hideRequired/>
            </div>
            
            <button className="form-button" onClick={() => handleClick()}>Test Connection</button>
        </div>
    )
}

export default Connect;
